var map = {
	"./CardCentros": 70901,
	"./CardCentros.css": 69712,
	"./CardCentros.js": 70901,
	"./Clinicamedica/Clinicamedica": 1134,
	"./Clinicamedica/Clinicamedica.css": 18517,
	"./Clinicamedica/Clinicamedica.js": 1134,
	"./Electrocardiograma/Electrocardiograma": 36780,
	"./Electrocardiograma/Electrocardiograma.css": 9747,
	"./Electrocardiograma/Electrocardiograma.js": 36780,
	"./Laboratorio/Laboratorio": 25946,
	"./Laboratorio/Laboratorio.css": 52705,
	"./Laboratorio/Laboratorio.js": 25946,
	"./Radiologia/Radiologia": 86738,
	"./Radiologia/Radiologia.css": 49293,
	"./Radiologia/Radiologia.js": 86738
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87277;